module.exports = __webpack_public_path__ + "img/meituan-propa.0338e728.png";